'use client';

import classNames from 'classnames';
import { useState } from 'react';
import { EyeIcon as Show } from '@heroicons/react/24/outline';

import { Global } from '@/types/sanity.types';
import { MaskTextProps } from './MaskText';
import { ButtonGhost } from '../Buttons';

type MaskTextClientProps = MaskTextProps & {
  global: Global;
};

export const MaskTextClient = ({ hidden, visible, global }: MaskTextClientProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const handleClick = () => setIsVisible(true);

  return (
    <span onClick={handleClick} className={classNames('flex items-center gap-2', { 'cursor-default': !isVisible })}>
      {isVisible ? visible : hidden}
      {!isVisible && (
        <ButtonGhost className="text-inherit opacity-50 hover:opacity-100 [&]:font-normal">
          <Show className="w-4" /> {global.misc?.click_to_show}
        </ButtonGhost>
      )}
    </span>
  );
};
